import { ERCButton } from 'components/button'
import { useState } from 'react'
import { Cart } from 'components/store/cart'
import Header from 'components/store/header'
import Layout from 'partials/layout'
import React from 'react'
import { apiRequest } from 'services'
import { baseURL } from 'services'
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { showModal, closeModal } from 'store/reducers/modal'
import Shoppingcartmodal from 'components/modal/shoppingcartmodal/shoppingcartmodal'
import { toast } from 'react-toastify'
import { clearCart } from 'store/reducers/cart'
import SavedProduct from './saveproduct'
import { productSaved } from 'store/reducers/products'
import { removeFromCart } from "store/reducers/cart";
import { motion } from 'framer-motion'


const ShoppingCart = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const cartDetails = useSelector((state) => state?.cart?.items)
    console.log(cartDetails)
    //    Addition of the total price of each Item in the array
    const totalCartPrice = cartDetails.reduce((acc, cartDetail) => {
        return acc + (cartDetail?.quantity * cartDetail?.discountedPrice);
      }, 0);
console.log(totalCartPrice)      

const token = useSelector((state) => state?.user?.data?.user?.data?.token);

//   console.log("tokenssss", token)
//  const token = JSON.parse(localStorage.getItem("token"),"{}")
//  console.log("toks",token)
//  const userToken = token?.data?.token

//  console.log(userToken)

const handleGenerateInvoice = () => {
    if (token) {
        navigate("/invoice")
    } else {
    const handleCloseModal = () => {
      dispatch(closeModal());
    };

    dispatch(showModal({
      content: <Shoppingcartmodal onClose={handleCloseModal} />
    }));
  };
}

const SavedProductBadToken = () => {
    const handleCloseModal = () => {
        dispatch(closeModal());
      };
  
      dispatch(showModal({
        content: <Shoppingcartmodal onClose={handleCloseModal} />
      }));
}
  
const getAllsaveProductByID = async () => {
    try {
          
        const response = await fetch(`${baseURL}/product/saved`, {
            // body: JSON.stringify,
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        })
        const result = await response.json()
            // toast.success(result?.data?.message)        
        // setProductSaved(result?.data?.details)
        dispatch(productSaved(result?.data?.details))
        
        console.log('Product saved successfully:', result);
    } catch (error) {
        toast.error(error)
        // console.error('Error saving product:', error);
    } finally {
        // Any final steps
    }
};

const saveProductByID = async (id) => {
    try {
        const data = {
            productId: id
          }
          
        const response = await fetch(`${baseURL}/product/save`, {
            body: JSON.stringify(data),
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        })
        const result = await response.json()
        // toast.success("Fetched Saved Product")
        // console.log('Product saved successfully:', result.status);
        if(result.status === 'success')
            {
                toast.success(result?.data?.message)
                productSaved((prev) => [...prev, result.data]);
                return true; // Indicate success
            } else if ( result.status === 'failed' && result.message === "Authorization denied! Token expired"){
        console.log('Error:', result.status);
        toast.error(result.message || "something went wrong!") 
                // navigate("/store-login-student")
                SavedProductBadToken()
                return false; // Indicate failure
            } else {
                console.log(result)
                return false; // Indicate failure
            }
            
    } catch (error) {

            } finally {
        // Any final steps
    }
};

// const savingProducts = useSelector((state) => state?.product?.productSavedByUser?.saved || [])
// console.log(savingProducts)
// for delete Product of the second Icon
const [productsDelete, setProductDelete] = useState(cartDetails)
console.log(productsDelete)

const deleteProductByID = async (id, index) => {
    try {
        const data = {
            productId: id
          }
        const response = await fetch(`${baseURL}/product/unsave`, {
            body: JSON.stringify(data),
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }

        })
        // const result = await response.json()
        const result = await response.json();
        console.log( "hello",result)
        toast.success(result?.message)        
        // Remove the deleted product from the productSave array
        setProductDelete((prevProducts) => prevProducts.filter((_, i) => i !== index));
        await getAllsaveProductByID();
        if (result.status === 'success') {
            // toast.success("Product deleted successfully.");
            return result; // Indicate success
        } else {
            // toast.error(result.message || "Something went wrong!");
            return result; // Indicate failure
        }
    } catch (error) {
        console.error('Error saving product:', error);
    } finally {
        // Any final steps
    }
};

const itemInCart = useSelector(state => state.cart.items); 


const handleRemoveFromCart = (id) => {
    // Update the Redux state to remove the specific item
    dispatch(removeFromCart({ id }));

    // Update the local storage after Redux state is updated
    const updatedCart = itemInCart.filter(item => item.id !== id);
    localStorage.setItem('cartItems', JSON.stringify(updatedCart));
    toast.success("item removed from cart")
  };

  const handleViewDetails = (id) => {
    navigate(`/product-details/${id}`);
    window.scrollTo(0,0);
    }



  return (
    <Layout>
    <Header/>
    <div className="w-full px-4 md:px-10 lg:px-20">
      {/* Go Back Button */}
      <div
        className="flex items-center gap-2 cursor-pointer mt-4 md:mt-6"
        onClick={() => {
          window.scrollTo(0, 0);
          navigate("/product-details/:id");
        }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <img
          src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1721893028/ERC/drowdown-arrow_suwan5.svg"
          alt="Back"
          className="w-5 h-5"
        />
        <p className="text-lg font-medium text-gray-700">Go Back</p>
      </div>

      {/* Cart Section */}
      <div className="flex flex-col md:flex-row justify-center items-start gap-10 my-6">
        {/* Cart Items */}
        <div className="w-full md:w-2/3 flex flex-col gap-6">
          {cartDetails.length === 0 ? (
            <motion.div
              className="text-center mt-20"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
            >
              <p className="text-2xl font-bold text-gray-700">
                YOUR WISH LIST IS EMPTY. NO ITEM HAS BEEN ADDED TO YOUR CART.
              </p>
            </motion.div>
          ) : (
            cartDetails.map((cartDetail, index) => (
              <motion.div
                key={index}
                className="transition transform hover:scale-105 hover:shadow-lg cursor-pointer bg-white p-4 rounded-lg"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                onClick={() => handleViewDetails(cartDetail.id)}
              >
                <Cart
                  img={cartDetail?.image}
                  title={cartDetail?.name}
                  slashPrice={cartDetail?.price}
                  amount={cartDetail?.discountedPrice}
                  description={cartDetail?.description}
                  quantity={cartDetail?.quantity}
                  totalPrice={cartDetail?.quantity * cartDetail?.discountedPrice}
                  onRemove={(e) => {
                    e.stopPropagation();
                    handleRemoveFromCart(cartDetail.id);
                  }}
                  onDeleteProduct={(e) => {
                    e.stopPropagation();
                    return saveProductByID(cartDetail.id, index);
                  }}
                  onSaveProduct={(e) => {
                    e.stopPropagation();
                    return deleteProductByID(cartDetail.id);
                  }}
                  isSaved={true}
                />
              </motion.div>
            ))
          )}
        </div>

        {/* Cart Summary */}
        <motion.div
          className="w-full md:w-1/3 bg-gray-100 p-6 rounded-lg shadow-md"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <p className="text-xl font-semibold text-gray-800 pb-4">Cart Summary</p>
          <div className="flex justify-between border-t py-3">
            <p className="text-lg font-medium text-gray-600">Subtotal</p>
            <p className="text-lg font-medium text-gray-600">NGN {totalCartPrice}</p>
          </div>
          <div className="flex justify-between border-t py-3">
            <p className="text-lg font-medium text-gray-600">Estimated Tax</p>
            <p className="text-lg font-medium text-gray-600">-</p>
          </div>
          <div className="flex justify-between border-t border-b py-4">
            <p className="text-xl font-semibold text-gray-800">Total</p>
            <p className="text-xl font-semibold text-gray-800">NGN {totalCartPrice}</p>
          </div>

          {/* Generate Invoice Button */}
          <motion.button
            className="w-full mt-4 bg-blue-600 text-white py-3 rounded-md text-lg font-semibold hover:bg-blue-700 transition"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={handleGenerateInvoice}
          >
            Generate Invoice
          </motion.button>

          {/* Payment Security Info */}
          <div className="flex justify-center py-4">
            <img
              src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1721953398/ERC/Frame_1134_jhro6o.svg"
              alt="Secure Payment"
            />
          </div>

          <p className="text-gray-600 text-sm text-center">
            We guarantee that you will receive the items or you can get a refund.{" "}
            <span className="text-blue-600 cursor-pointer">Learn More</span>
          </p>
        </motion.div>
      </div>
    </div>
    </Layout>
  )
}

export default ShoppingCart
